import classNames from "classnames";

import { Separator } from "@jti/core-components/components/Separator";
import { useTranslations } from "@jti/ui";

import { SubscriptionBillingDisclaimer } from "@checkout/components/SubscriptionBillingDisclaimer";

import { SubscriptionBenefits } from "../SubscriptionBenefits/SubscriptionBenefits";
import { SubscriptionPrices } from "../SubscriptionPrices/SubscriptionPrices";

import styles from "./SummarySubscriptionFooter.module.scss";

type SummarySubscriptionFooterProps = {
  displayPointsSection?: boolean;
  showSidebarBillingDisclaimer?: boolean;
};

export const SummarySubscriptionFooter = ({
  displayPointsSection = true,
  showSidebarBillingDisclaimer = true,
}: SummarySubscriptionFooterProps) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.footerContainer}>
      <div className={styles.separatorOverrides}>
        <Separator />
      </div>
      <SubscriptionBenefits />
      <div className={styles.separatorOverrides}>
        <Separator />
      </div>
      <SubscriptionPrices />
      {showSidebarBillingDisclaimer && <SubscriptionBillingDisclaimer />}
      {/* TODO: add functionality of collecting points */}
      {displayPointsSection && (
        <div className={classNames(styles.section, styles.sectionPoints)} data-testid="subscription-summary-points">
          <p className={styles.smallText}>{__("summarySubscription.collectPoints", [0])}</p>
        </div>
      )}
    </div>
  );
};
